// extracted by mini-css-extract-plugin
module.exports = {"root":"Note_root__aND8i","info":"Note_info__2bJX6","note":"Note_note__3stXV","actions":"Note_actions__xcCUv"};